'use strict';

var React = require('react');

var SvgFoodMajor = function SvgFoodMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.25 4a.75.75 0 0 1 .75-.75c.592 0 1.1.11 1.52.344.429.238.716.576.9.946.142.282.223.585.269.877l.478-.192a4.07 4.07 0 0 1 5.583 3.78v.852c0 1.511-.288 3.008-.85 4.411l-.143.36a3.377 3.377 0 0 1-4.646 1.766l-.186-.093a2.069 2.069 0 0 0-1.85 0l-.186.093a3.377 3.377 0 0 1-4.646-1.767l-.121-.303a12.187 12.187 0 0 1-.872-4.527v-1.135a3.75 3.75 0 0 1 4.936-3.557l.976.325a1.214 1.214 0 0 0-.083-.22.676.676 0 0 0-.287-.304c-.142-.08-.384-.156-.792-.156a.75.75 0 0 1-.75-.75Zm.462 2.528a2.25 2.25 0 0 0-2.962 2.134v1.135c0 1.36.26 2.707.764 3.97l.122.303a1.877 1.877 0 0 0 2.582.982l.186-.093a3.568 3.568 0 0 1 3.192 0l.185.093a1.877 1.877 0 0 0 2.583-.982l.144-.359c.49-1.226.742-2.534.742-3.854v-.852a2.57 2.57 0 0 0-3.525-2.387l-1.447.578a.75.75 0 0 1-.515.016l-2.051-.684Z"
  }));
};
SvgFoodMajor.displayName = "FoodMajor";

exports.SvgFoodMajor = SvgFoodMajor;
